webpackJsonp([0],{

/***/ "+p6U":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
    data: function data() {
        return {
            pro_items: [{ url: 'http://img3.imgtn.bdimg.com/it/u=1214593966,76569341&fm=27&gp=0.jpg', title: '个人博客', text: '个人博客正在努力开发中~~~~' }]
        };
    },

    methods: {}
});

/***/ }),

/***/ "/Lvv":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({});

/***/ }),

/***/ "/wlr":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "13r8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_blog_vue__ = __webpack_require__("+p6U");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3c2773f4_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_blog_vue__ = __webpack_require__("tZ7X");
function injectStyle (ssrContext) {
  __webpack_require__("4/9O")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-3c2773f4"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_blog_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3c2773f4_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_blog_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "4/9O":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "6sN5":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',[_c('div',{staticClass:"x-content-wrapper"},[_c('div',{staticClass:"copyright"},[_c('transition',{attrs:{"name":"fade","mode":"out-in"}},[_c('keep-alive',[_c('router-view')],1)],1)],1)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "730o":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "8+hV":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({});

/***/ }),

/***/ "9m2s":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',{staticClass:"x-pro-ul"},_vm._l((_vm.pro_items),function(pro){return _c('li',{staticClass:"x-pro-li"},[_c('a',{attrs:{"href":pro.href}},[_c('div',{staticClass:"pro-img"},[_c('img',{attrs:{"src":pro.url,"alt":""}}),_vm._v(" "),_c('div',{staticClass:"ewm"},[_c('img',{attrs:{"src":'/static/images/'+pro.ewm,"alt":""}})])]),_vm._v(" "),_vm._m(0,true),_vm._v(" "),_c('h2',{staticClass:"x-pro-title t-o-e-y"},[_vm._v(_vm._s(pro.title))]),_vm._v(" "),_c('p',{staticClass:"x-pro-text t-o-e-n-3"},[_vm._v(_vm._s(pro.text))])])])}))}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"x-pro-time"},[_c('span',[_vm._v("小九")]),_vm._v("  2017-09-08")])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "BFJ2":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "CArI":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Cdyq":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_other_vue__ = __webpack_require__("8+hV");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f100c3fe_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_other_vue__ = __webpack_require__("SuMs");
function injectStyle (ssrContext) {
  __webpack_require__("/wlr")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-f100c3fe"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_other_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f100c3fe_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_other_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "DXTr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_about_vue__ = __webpack_require__("aTdf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6b630ad3_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_about_vue__ = __webpack_require__("EiXY");
function injectStyle (ssrContext) {
  __webpack_require__("mmGR")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-6b630ad3"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_about_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6b630ad3_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_about_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "EiXY":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('p',[_vm._v("about")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "FPFF":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"layout"}},[_c('x-header',{staticClass:"l-header"}),_vm._v(" "),_c('x-content',{staticClass:"l-content"}),_vm._v(" "),_c('x-footer',{staticClass:"l-footer"})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "NHnr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__layout__ = __webpack_require__("Xb4L");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__router__ = __webpack_require__("YaEn");
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.




__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].config.productionTip = false;

new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]({
  el: '#app',
  router: __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */],
  template: '<Layout/>',
  components: { Layout: __WEBPACK_IMPORTED_MODULE_1__layout__["a" /* default */] }
});

/***/ }),

/***/ "NTC3":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({});

/***/ }),

/***/ "QIMk":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('header',[_c('div',{staticClass:"x-header-wrapper"},[_c('nav',{staticClass:"navigator",attrs:{"id":"navigator"}},[_c('transition',{attrs:{"name":"fade"}},[(_vm.xShow)?_c('div',{staticClass:"_m-nav-wrapper"},[_c('ul',{staticClass:"_nav-items"},_vm._l((_vm.nav_items),function(i){return _c('li',{staticClass:"_nav-item",on:{"click":_vm.toggleMenu}},[_c('keep-alive',[_c('router-link',{attrs:{"to":i.href}},[_vm._v(" "+_vm._s(i.item)+" ")])],1)],1)}))]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"_nav-logo"},[_c('a',{attrs:{"href":""}},[_c('img',{attrs:{"src":_vm.imgLogo,"alt":""}})])]),_vm._v(" "),_c('div',{staticClass:"_nav-wrapper"},[_c('ul',{staticClass:"_nav-items"},_vm._l((_vm.nav_items),function(i){return _c('li',{staticClass:"_nav-item"},[_c('router-link',{attrs:{"to":i.href}},[_vm._v(" "+_vm._s(i.item)+" ")])],1)}))]),_vm._v(" "),_c('div',{staticClass:"menu-button",on:{"click":_vm.toggleMenu}},[_c('div',{staticClass:"bar"}),_vm._v(" "),_c('div',{staticClass:"bar"}),_vm._v(" "),_c('div',{staticClass:"bar"})])],1)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "SuMs":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._v("\n    other\n")])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "T7dY":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_production_vue__ = __webpack_require__("luez");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3df7c51e_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_production_vue__ = __webpack_require__("9m2s");
function injectStyle (ssrContext) {
  __webpack_require__("BFJ2")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-3df7c51e"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_production_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3df7c51e_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_production_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "Xb4L":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_layout_vue__ = __webpack_require__("j2ZX");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_032f7f16_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_layout_vue__ = __webpack_require__("FPFF");
function injectStyle (ssrContext) {
  __webpack_require__("jeVh")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_layout_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_032f7f16_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_layout_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "YaEn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__("/ocq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_content_blog_vue__ = __webpack_require__("13r8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_content_about_vue__ = __webpack_require__("DXTr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_content_production_vue__ = __webpack_require__("T7dY");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_content_other_vue__ = __webpack_require__("Cdyq");



__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);






/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
    mode: 'history',
    base: '/',
    routes: [{
        path: '/',
        component: __WEBPACK_IMPORTED_MODULE_4__components_content_production_vue__["a" /* default */]
    }, {
        path: '/blog',
        component: __WEBPACK_IMPORTED_MODULE_2__components_content_blog_vue__["a" /* default */]
    }, {
        path: '/about',
        component: __WEBPACK_IMPORTED_MODULE_3__components_content_about_vue__["a" /* default */]
    }, {
        path: '/production',
        component: __WEBPACK_IMPORTED_MODULE_4__components_content_production_vue__["a" /* default */]
    }, {
        path: '/other',
        component: __WEBPACK_IMPORTED_MODULE_5__components_content_other_vue__["a" /* default */]
    }]
}));

/***/ }),

/***/ "ZxYM":
/***/ (function(module, exports) {

if (/Android (\d+\.\d+)/.test(navigator.userAgent)) {
    var version = parseFloat(RegExp.$1);
    if (version > 2.3) {
        var phoneScale = parseInt(window.screen.width) / 640;
        document.write('<meta name="viewport" content="width=640, minimum-scale = ' + phoneScale + ', maximum-scale = ' + phoneScale + ', target-densitydpi=device-dpi">');
    } else {
        document.write('<meta name="viewport" content="width=640, target-densitydpi=device-dpi">');
    }
} else {
    document.write('<meta name="viewport" content="width=640, user-scalable=no, target-densitydpi=device-dpi">');
}

/***/ }),

/***/ "aTdf":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({});

/***/ }),

/***/ "dQCR":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_footer_vue__ = __webpack_require__("NTC3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_9950988a_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_footer_vue__ = __webpack_require__("vaHK");
function injectStyle (ssrContext) {
  __webpack_require__("uQYt")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-9950988a"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_footer_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_9950988a_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_footer_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "h/N8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

//    import luan from '../../assets/images/x-header-logo.png'
var url = '/static/images/';
/* harmony default export */ __webpack_exports__["a"] = ({
    data: function data() {
        return {
            imgLogo: url + 'x-header-logo.png',
            xShow: false,
            nav_items: [{ item: 'BLOG', href: '/blog' }, { item: 'PRODUCTION', href: '/production' }, { item: 'ABOUT', href: '/about' }, { item: 'OTHER', href: '/other' }]
        };
    },

    computed: {
        getMenuButton: function getMenuButton() {
            return document.querySelector('.menu-button');
        },
        getMNavWrapper: function getMNavWrapper() {
            return document.querySelector('._m-nav-wrapper');
        },
        getMNavItems: function getMNavItems() {
            return document.querySelector('._nav-items');
        }
    },
    methods: {
        toggleMenu: function toggleMenu() {
            this.xShow = !this.xShow;
            if (this.getMenuButton.classList.toggle('cross')) {
                //                this.getMNavWrapper.classList.remove('xHide')
            } else {}
        }
    }
});

/***/ }),

/***/ "hxP8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_header_vue__ = __webpack_require__("h/N8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_41a5757a_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_header_vue__ = __webpack_require__("QIMk");
function injectStyle (ssrContext) {
  __webpack_require__("xSu7")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-41a5757a"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_header_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_41a5757a_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_header_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "j2ZX":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__common_css_init_css__ = __webpack_require__("CArI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__common_css_init_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__common_css_init_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__common_js_setviewport__ = __webpack_require__("ZxYM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__common_js_setviewport___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__common_js_setviewport__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_header_header_vue__ = __webpack_require__("hxP8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_content_content_vue__ = __webpack_require__("lrMX");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_footer_footer_vue__ = __webpack_require__("dQCR");
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
    components: {
        'xHeader': __WEBPACK_IMPORTED_MODULE_2__components_header_header_vue__["a" /* default */],
        'xContent': __WEBPACK_IMPORTED_MODULE_3__components_content_content_vue__["a" /* default */],
        'xFooter': __WEBPACK_IMPORTED_MODULE_4__components_footer_footer_vue__["a" /* default */]
    }
});

/***/ }),

/***/ "jeVh":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "lrMX":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_content_vue__ = __webpack_require__("/Lvv");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_164163ad_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_content_vue__ = __webpack_require__("6sN5");
function injectStyle (ssrContext) {
  __webpack_require__("730o")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-164163ad"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_content_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_164163ad_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_content_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "luez":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


var host = 'https://chinajiu.github.io/code/';

/* harmony default export */ __webpack_exports__["a"] = ({
    data: function data() {
        return {
            pro_items: [{ url: 'https://xproject.oss-cn-beijing.aliyuncs.com/myblog/project/g1.gif', title: '时光胶囊', href: host + 'H9/', text: '一粒当代给未来的时光胶囊', ewm: 'H9.png' }, { url: 'https://xproject.oss-cn-beijing.aliyuncs.com/myblog/project/newp-1.jpg', title: '中秋月饼', href: host + 'H1/', text: '五仁月饼', ewm: 'H1.png' }, { url: 'https://xproject.oss-cn-beijing.aliyuncs.com/myblog/project/g9.gif', title: '打地鼠', href: host + 'H4/', text: '"鸡"不可失', ewm: 'H4.png' }, { url: 'https://xproject.oss-cn-beijing.aliyuncs.com/myblog/project/g11.gif', title: '金茂杂志', href: host + 'H5/', text: '实至名归，不负金茂之名', ewm: 'H5.png' }, { url: 'https://xproject.oss-cn-beijing.aliyuncs.com/myblog/project/newp-2.jpg', title: '国瑞', href: host + 'H6/', text: '国瑞熙墅', ewm: 'H6.png' }, { url: 'https://xproject.oss-cn-beijing.aliyuncs.com/myblog/project/g2.gif', title: '寻宝大作战', href: host + 'H2/', text: '寻宝大作战，欢乐好礼送', ewm: 'H2.png' }, { url: 'https://xproject.oss-cn-beijing.aliyuncs.com/myblog/project/g10.gif', title: '金茂有书声', href: host + 'H8/', text: '金茂府理想有书声', ewm: 'H8.png' }, { url: 'https://xproject.oss-cn-beijing.aliyuncs.com/myblog/project/newp-3.jpg', title: '圣诞节', href: host + 'H10/', text: '圣诞节', ewm: 'H10.png' }, { url: 'https://xproject.oss-cn-beijing.aliyuncs.com/myblog/project/newp-4.jpg', title: '远洋', href: host + 'H3/', text: '健康生活家', ewm: 'H3.png' }]
        };
    },

    methods: {}
});

/***/ }),

/***/ "mmGR":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "tZ7X":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',{staticClass:"x-pro-ul"},_vm._l((_vm.pro_items),function(pro){return _c('li',{staticClass:"x-pro-li"},[_c('router-link',{attrs:{"to":"/production"}},[_c('div',{staticClass:"pro-img"},[_c('img',{attrs:{"src":pro.url,"alt":""}})])]),_vm._v(" "),_vm._m(0,true),_vm._v(" "),_c('h2',{staticClass:"x-pro-title t-o-e-y"},[_vm._v(_vm._s(pro.title))]),_vm._v(" "),_c('p',{staticClass:"x-pro-text t-o-e-n-3"},[_vm._v(_vm._s(pro.text))]),_vm._v(" "),_c('p',{staticClass:"x-pro-text t-o-e-n-3"},[_vm._v("项目请移至production")])],1)}))}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"x-pro-time"},[_c('span',[_vm._v("小九")]),_vm._v("  2017-09-08")])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "uQYt":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "vaHK":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('footer',[_c('div',{staticClass:"x-header-wrapper"},[_c('div',{staticClass:"copyright"},[_c('p',[_vm._v("版权")]),_vm._v(" "),_c('p',[_vm._v("xiaojiu© 2017 - 2019")])])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "xSu7":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ })

},["NHnr"]);


// WEBPACK FOOTER //
// static/js/app.e521be35a61f9c8ca501.js